import {Stack} from '@mui/material';
import {styled} from '@mui/material/styles';

export const Container = styled('div')(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	padding: '24px 32px',
	height: '100%',
	gap: '24px',
	justifyContent: 'space-between',

	[theme.breakpoints.down('sm')]: {
		padding: '24px 16px',
	},
}));

export const GridContainer = styled('div')(({theme}) => ({
	display: 'grid',
	gridTemplateColumns: 'repeat(3, 1fr)',
	gap: theme.spacing(1.5),
	width: '100%',
	[theme.breakpoints.down('md')]: {
		gridTemplateColumns: 'repeat(2, 1fr)',
	},
	[theme.breakpoints.down('sm')]: {
		gridTemplateColumns: '1fr',
	},
}));
export const FiltersContainer = styled(Stack)`
	width: 100%;
	padding: 0px 0px;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`;
